import React from "react";

import Main from "./components/pages/Routes";
function App() {
  return <Main />;
}

export default App;
